import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import CircularProgress from '@mui/material/CircularProgress';

import { getAuth, onAuthStateChanged } from 'firebase/auth';
import config from '../conf/config';
// import menuItems from '../navigation/appMenu/menuItems';

const ProtectedRoute = (props: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (config.appMode === 'dev') {
      setLoading(false);
    } else {
      const unsubscribe = onAuthStateChanged(getAuth(), (userObj) => {
        if (userObj) {
          setLoading(false);

          // const currentPath = menuItems.find(
          //   (menuItem) => menuItem.path === location.pathname
          // );

          // if (currentPath?.verifiedUsersOnly && !userObj.emailVerified) {
          if (location.pathname !== '/' && !userObj.emailVerified) {
            navigate('/');
          }
        } else {
          navigate('/login');
          setLoading(false);
        }
      });
      return () => unsubscribe();
    }
  }, [location, navigate]);

  return loading ? (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '80%',
      }}
    >
      <CircularProgress />
    </div>
  ) : (
    <React.Fragment>{props.children}</React.Fragment>
  );
};
export default ProtectedRoute;
